import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './app/App'
import './styles/globals.css'

// Initialize dark mode from localStorage
const theme = localStorage.getItem('theme') || 'light'
if (theme === 'dark') {
  document.documentElement.classList.add('dark')
  document.documentElement.classList.remove('light')
} else {
  document.documentElement.classList.remove('dark')
  document.documentElement.classList.add('light')
}

// Wait for WebApp to be ready before rendering
function initializeApp() {
  if (import.meta.env.DEV) {
    console.log('[Main] Initializing app...')
  }

  const maxWaitTime = 5000 // 5 seconds max wait
  const checkInterval = 100 // Check every 100ms
  let elapsedTime = 0

  const waitForWebApp = () => {
    const webapp = (window as any).WebApp

    if (webapp) {
      if (import.meta.env.DEV) {
        console.log('[Main] WebApp found, calling ready()')
      }
      try {
        if (typeof webapp.ready === 'function') {
          webapp.ready()
        }
      } catch (err) {
        console.warn('[Main] Error calling WebApp.ready():', err)
      }

      if (import.meta.env.DEV) {
        console.log('[Main] WebApp ready, rendering app', {
          platform: webapp.platform,
          version: webapp.version,
          initData: !!webapp.initData,
          initDataUnsafe: !!webapp.initDataUnsafe,
        })
      }

      renderApp()
    } else if (elapsedTime < maxWaitTime) {
      if (import.meta.env.DEV) {
        console.log(`[Main] Waiting for WebApp... (${elapsedTime}ms)`)
      }
      elapsedTime += checkInterval
      setTimeout(waitForWebApp, checkInterval)
    } else {
      console.warn('[Main] WebApp not available after 5 seconds, proceeding anyway (likely web browser)')
      renderApp()
    }
  }

  waitForWebApp()
}

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp)
} else {
  initializeApp()
}
